import { Component } from '@theme/component';

/**
 * Étiquette « taille mannequin » Maghla : affiche le texte alternatif de
 * chaque média de la galerie produit (maquette 2192:559, étiquette en haut à
 * gauche de l'image). Le texte alternatif est saisi par le client dans
 * l'admin sur chaque image (« Taille portée : M »).
 *
 * L'élément se place dans la section produit (block `mg-media-labels`) et
 * pose une étiquette dans chaque `.product-media` de la galerie de sa section.
 * La galerie est observée : Horizon peut la re-rendre (changement de variante).
 *
 * @extends Component<{}>
 */
class MgMediaLabels extends Component {
  requiredRefs = [];

  /** @type {MutationObserver | undefined} */
  #observer;

  connectedCallback() {
    super.connectedCallback();
    this.#apply();

    const gallery = this.#gallery();
    if (!gallery) return;

    this.#observer = new MutationObserver(() => this.#apply());
    this.#observer.observe(gallery, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }

  /**
   * @returns {Element | null | undefined}
   */
  #gallery() {
    return this.closest('.shopify-section')?.querySelector('media-gallery');
  }

  #apply() {
    const gallery = this.#gallery();
    if (!gallery) return;

    const productTitle = (this.dataset.productTitle ?? '').trim().toLowerCase();
    const onlyCustom = this.hasAttribute('data-only-custom');
    const position = this.dataset.position || 'top-left';

    for (const media of gallery.querySelectorAll('.product-media')) {
      if (media.querySelector('.mg-media-label')) continue;

      const image = media.querySelector('img');
      const alt = (image?.getAttribute('alt') ?? '').trim();
      if (!alt) continue;
      if (onlyCustom && alt.toLowerCase() === productTitle) continue;

      const label = document.createElement('span');
      label.className = `mg-media-label mg-media-label--${position}`;
      label.textContent = alt;
      // Le texte est déjà porté par l'attribut alt de l'image
      label.setAttribute('aria-hidden', 'true');
      media.append(label);
    }
  }
}

if (!customElements.get('mg-media-labels')) {
  customElements.define('mg-media-labels', MgMediaLabels);
}
